import { errorFromResponse, notifications } from '~/app/notifications'
import AppButton from '@theme/components/atom/AppButton'
import AppImage from '@theme/components/atom/AppImage'
import AppInput from '@theme/components/atom/AppInput'
import AppTitle from '@theme/components/atom/AppTitle'
import BranchBox from '@theme/components/content/BranchBox'
import BranchMixin from '~/mixins/BranchMixin'
import BranchesMap from '@theme/components/content/BranchesMap'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import Divider from '@theme/components/molecule/Divider'
import EmployeeList from '@theme/components/content/EmployeeList'
import FoxentryFormMixin from '~/mixins/FoxentryFormMixin'
import GoogleMap from '@theme/components/utils/GoogleMap/GoogleMapLazy'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import LayoutBase from '@theme/components/shop/LayoutBase'
import LoadingMixin from '~/mixins/LoadingMixin'
import PageContactBillingInformation from '@theme/components/content/PageContactBillingInformation'
import ProductsVisited from '@theme/components/product/ProductsVisited/ProductsVisitedLazy'
import ProvideValidator from '~/app/ProvideValidator'
import RequiredSign from '@theme/components/atom/RequiredSign'
import SeoMixin from '~/mixins/SeoMixin'
import UniqueSellingPoints from '@theme/components/shop/UniqueSellingPoints'

export default {
  components: {
    AppTitle,
    AppImage,
    AppButton,
    AppInput,
    BranchBox,
    BranchesMap,
    Breadcrumbs,
    Divider,
    EmployeeList,
    GoogleMap,
    LayoutBase,
    PageContactBillingInformation,
    ProductsVisited,
    RequiredSign,
    UniqueSellingPoints,
  },
  created() {
    this.CLASS_ELEMENT = 'col-24'
    this.CLASS_ELEMENTS_OUTSIDE_NO_LABEL = 'col-24'
    this.CLASS_LABEL = 'col-form-label col-24'
    this.CLASS_ROW = 'form-group row'
  },
  mixins: [BranchMixin, FoxentryFormMixin, ImageUrlMixin, LoadingMixin, ProvideValidator, SeoMixin],
  head() {
    return this.getSeoHead({ yamlKey: 'PageContact' })
  },
  data() {
    return {
      loading: false,
      submitted: false,
      input: {
        email: '',
        name: '',
        question: '',
      },
      breadcrumbs: [
        {
          title: this.$t('PageContact.breadcrumbs.index'),
          path: this.localePath({ name: 'contact' }),
        },
      ],
      slugPrivacyPolicy: this.$t('globals.pageSlugs.privacyPolicy'),
    }
  },
  props: {
    branchPrimary: Object,
    branches: Array,
    contact: {
      type: Object,
      default() {
        return this.$store.state.globals.contact
      },
    },
  },
  computed: {
    branchPrimaryMarker() {
      if (!this.branchPrimary) return
      return {
        title: this.branchPrimary.title,
        image:
          this.branchPrimary.branch_map_images && this.branchPrimary.branch_map_images.length > 0
            ? this.branchPrimary.branch_map_images[0].path
            : '',
        markerDescription: this.compileBranchDescriptionForGoogleMapMarker(
          this.branchPrimary.opening_hours,
          this.branchPrimary.branch_map_description,
        ),
        position: {
          lat: Number(this.branchPrimary.gps_latitude),
          lng: Number(this.branchPrimary.gps_longitude),
        },
      }
    },
    employees() {
      return this.branchPrimary && this.branchPrimary.employees
        ? this.branchPrimary.employees.map(employee => employee.entity)
        : []
    },
  },
  methods: {
    async submit() {
      if (!(await this.foxentryFormSubmit('#PageContactForm'))) {
        return
      }
      if (!(await this.$validator.validate())) {
        notifications.danger(this.$validator.errors.items[0].msg)
        return
      }
      this.startLoading()
      try {
        const url = `${this.$env.STORE_URL}/api/v1/contact-form`
        const message = { name: this.input.name, email: this.input.email, text: this.input.question }
        await this.$axios.$post(url, message)
        notifications.success(this.$t('PageContact.sentNotification'))
        this.input.name = ''
        this.input.email = ''
        this.input.question = ''
        this.$validator.reset()
      } catch (e) {
        errorFromResponse(e.response)
      }
      this.stopLoading()
    },
  },
}
